import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import * as Styled from "./styles";

interface DriverReadViewProps {
  driverName?: string;
  driverSurname?: string;
  canSelect: boolean;
  canChange: boolean;
  onSelect: () => void;
}

function trimPart(value?: string): string {
  return (value ?? "").trim();
}

function buildDisplayAndInitial(
  firstName?: string,
  surname?: string,
): { display: string; initial: string } {
  const f = trimPart(firstName);
  const s = trimPart(surname);
  const display = [f, s].filter(Boolean).join(" ");
  const sourceForInitial = f || s;
  const initial = sourceForInitial
    ? sourceForInitial.charAt(0).toLocaleUpperCase("pt-BR")
    : "";
  return { display, initial };
}

function DriverReadView({
  driverName,
  driverSurname,
  canSelect,
  canChange,
  onSelect,
}: DriverReadViewProps): JSX.Element {
  const { t } = useTranslation();

  const { display, initial } = useMemo(
    () => buildDisplayAndInitial(driverName, driverSurname),
    [driverName, driverSurname],
  );

  const hasDriver = Boolean(display);
  const canShowAction = canSelect || canChange;
  const buttonLabel = hasDriver ? t("changeDriver") : t("selectDeliveryPerson");

  return (
    <Styled.ContainerDriver>
      <Styled.ContainerDrive $hasDriver={hasDriver}>
        {hasDriver && (
          <Styled.ContainerDriverSelected>
            <Styled.DriverAvatarCircle aria-hidden>
              {initial}
            </Styled.DriverAvatarCircle>
            <Styled.DriverDisplayName title={display}>
              {display}
            </Styled.DriverDisplayName>
          </Styled.ContainerDriverSelected>
        )}
        {canShowAction && (
          <Styled.Button type="button" onClick={onSelect}>
            <Styled.ButtonAccept>
              {buttonLabel.toUpperCase()}
            </Styled.ButtonAccept>
          </Styled.Button>
        )}
      </Styled.ContainerDrive>
    </Styled.ContainerDriver>
  );
}

export default DriverReadView;
